import { useQuery } from '@tanstack/react-query';

import { checkUserHasSlot } from './about-us.api';

export const useCheckUserHasSlotQuery = (enabled: boolean) => {
  return useQuery({
    queryKey: ['about-us', 'has-slot'],
    queryFn: () => checkUserHasSlot(),
    enabled: !!enabled,
  });
};
